// npm i leaflet --save
// npm i leaflet-gesture-handling --save

import 'leaflet';
import 'leaflet-gesture-handling';

const initMap = (mapElement) => {
  const latlng = [mapElement.dataset.lat, mapElement.dataset.lng];

  const map = L.map(mapElement, {zoomControl: false, attributionControl: false, gestureHandling: true}).setView(latlng, 16);

  L.tileLayer('https://a.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
    attribution: '<a href=\"https://osmfoundation.org/wiki/Terms_of_Use\" target=\"_blank\">OpenStreetMap</a>',
    maxZoom: 16,
  }).addTo(map);

  const marker = L.icon({
    iconUrl: mapElement.dataset.marker1x,
    iconRetinaUrl: mapElement.dataset.marker2x,
    iconSize:    [33, 40],
    iconAnchor:  [16.5, 40]
  });
  L.marker(latlng, {icon: marker}).addTo(map);
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-map').forEach((map) => {
    initMap(map)
  });
});
